import { ShimmerEffect } from "@/design-system/Atoms";

const ConsultationsTableShimmer = () => {
  return (
    <div className="overflow-x-auto touch-auto bg-white rounded-lg p-5">
      <table className="w-full text-sm text-left text-[#3B4151] border-collapse mb-4">
        <thead className="text-black">
          <tr>
            <th className="px-2 py-2">
              <ShimmerEffect className="h-[20px] w-[20px]" />
            </th>
            {[...Array(6)].map((_, index) => (
              <th key={index} className="px-2 py-2">
                <ShimmerEffect className="h-[20px] w-[100px]" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr className="">
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[20px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
          </tr>
          <tr className="">
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[20px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
          </tr>
          <tr className="">
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[20px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
          </tr>
          <tr className="">
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[20px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
            <td className="px-2 py-2">
              <ShimmerEffect className="h-[16px] w-[100px]" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ConsultationsTableShimmer;
